module.exports = __webpack_public_path__ + "02_short_grey.7405c067.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_short_grey.png
// module id = 0hSJ
// module chunks = 0